/**
 * Pages
 */

export * from './pages/TransfersList/TransfersList';
export * from './pages/TransferOrderCreate/TransferOrderCreate';
export * from './pages/TransferOrderDetail/TransferOrderDetail';
